import { render, staticRenderFns } from "./RuleFilters.vue?vue&type=template&id=faf5771c&scoped=true"
import script from "./RuleFilters.vue?vue&type=script&lang=js"
export * from "./RuleFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faf5771c",
  null
  
)

export default component.exports